import * as React from 'react';
import styles from './index.less';
import Sider from './Sider';
import * as AHooks from 'ahooks';
import { connect } from 'dva';
import { CollectionManagerState, ConnectState } from '@/models/connect';
import { Dispatch } from 'redux';
import { OnMount_Page_Action, OnUnmount_Page_Action } from '@/models/collectionManager';
import { RouteComponentProps } from 'react-router/index';
import FSimpleBar from '@/components/FSimpleBar';

interface SidebarProps extends RouteComponentProps<{ id: string }> {
  dispatch: Dispatch;
  collectionManager: CollectionManagerState;
  children: React.ReactNode;
}

function Sidebar({ children, dispatch, collectionManager, match }: SidebarProps) {
  // console.log(match, 'matchisdjflksjdlkflkjl )))))))))))))))))))))) ######################################');
  AHooks.useMount(() => {
    // console.log(match, 'matchisdjflksjdlkflkjl )))))))))))))))))))))) ######################################');
    dispatch<OnMount_Page_Action>({
      type: 'collectionManager/onMount_Page',
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmount_Page_Action>({
      type: 'collectionManager/onUnmount_Page',
    });
  });

  return (
    <div className={styles.leftRight}>
      <div className={styles.Slider}>
        <div>
          <Sider />
        </div>
      </div>
      <div className={styles.rightContent}>
        <FSimpleBar height={'calc(100vh - 70px)'}>
          <div className={styles.rightContent_inner}>{children}</div>
        </FSimpleBar>
      </div>
    </div>
  );
}

export default connect(({ collectionManager }: ConnectState) => ({
  collectionManager: collectionManager,
}))(Sidebar);
